import { PerspectiveCamera } from 'three';

const generateCameraData = (camera: PerspectiveCamera) => {
  const { position, aspect, fov, rotation } = camera;
  return {
    position: {
      x: position.x,
      y: position.y,
      z: position.z,
    },
    rotation: {
      x: rotation.x,
      y: rotation.y,
      z: rotation.z,
    },
    fov,
    aspect,
  };
};

export default generateCameraData;
